var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-overlay',{attrs:{"show":_setup.loading,"rounded":"sm","opacity":"0.8"}},[_c('span',{style:({ opacity: _setup.loading ? 0.5 : 1 })},[_c('div',{attrs:{"id":"payPalButton","loading":_setup.loading}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }